import { HomeActionTypes } from './home.types';

const homeContentGetRequest = () => ({ type: HomeActionTypes.HOME_GET_REQUEST });
const homeContentGetSuccess = () => ({ type: HomeActionTypes.HOME_GET_SUCCESS });
const homeContentGetFailure = () => ({ type: HomeActionTypes.HOME_GET_FAILURE });
const homeContentSet = payload => ({ type: HomeActionTypes.HOME_SET, payload });
const homeContentLoading = payload => ({ type: HomeActionTypes.HOME_LOADING, payload });
const homeContentResetState = () => ({ type: HomeActionTypes.HOME_RESET_STATE });

const sawHome = () => ({ type: HomeActionTypes.SAW_HOME });
const menuIsOpen = payload => ({ type: HomeActionTypes.MENU_IS_OPEN, payload });

const actions = {
  getHomeContent: {
    request: homeContentGetRequest,
    success: homeContentGetSuccess,
    failure: homeContentGetFailure,
    set: homeContentSet,
    reset: homeContentResetState,
  },
  loading: homeContentLoading,
  sawHome,
  menuIsOpen,
};

export default actions;
